import { selectChangeMessageForDate } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForDate';
import { selectGoalSubItem } from '@newStore/documentUI/transformContent/llinkidSelectors';
import { type BuildingBlockNodeConfig, RequiredType } from '@nodeTypeConfig/configTypes';
import { llinkidDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { addMonths } from 'date-fns';

const LLINKID_CONCRETIZATION: BuildingBlockNodeConfig = {
  nodeSelector: selectGoalSubItem,
  information: {
    single: 'Concretisering',
    plural: 'Concretiseringen',
  },
  createDefaults: {
    newUntilDate: addMonths(new Date().setUTCHours(0, 0, 0, 0), 3).toISOString(),
  },
  buildingBlocks: [],
  edit: [
    llinkidDescriptionComponent,
    {
      component: 'newUntilDate',
      property: 'newUntilDate',
      label: 'Toon als nieuw tot',
      reactComponent: 'AsideDatePicker',
      asideChangeMessageSelector: selectChangeMessageForDate,
      required: RequiredType.ERROR,
      options: {
        openTo: 'day',
      },
      width: 4,
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'description',
  },
};

export default LLINKID_CONCRETIZATION;
